<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData"  ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="status" label="状态">
              <el-tag type="success" v-if="formData.status == '1'">空闲</el-tag>
            <el-tag   v-if="formData.status == '2'">工作中</el-tag>
            <el-tag type="warning" v-if="formData.status == '3'">外出</el-tag>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号"  >
              {{ formData.plateNumber||'--' }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driver" label="司机姓名">
              {{ formData.driver||'--' }}

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverPhone" label="司机手机">
              {{ formData.driverPhone||'--' }}

          </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'vehicleManageDetail',

  data () {
    return {
      formData: {

        plateNumber: '',
        status: ''
      },

      loading: false

    }
  },
  created () {
    if (this.plateId) {
      this.loadData()
    }
  },
  computed: {
    plateId () {
      return this.$route.query.plateId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.vehicleManage.selectPaVehicleInfoByPlateId, {
          params: { plateId: this.plateId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

</style>
